import { alpha } from "@mui/material"
import { blueGrey, lightBlue } from "../../../../../mp-core/themes/palette"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ palette, spacing }) => ({
  tabsFlexContainer: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    gap: spacing(1)
  },
  subjectRoot: {
    background: "transparent",
    zIndex: 101,
    fontSize: 14,
    minWidth: 0,
    color: blueGrey[700],
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 20,
    paddingRight: 20,
    marginRight: 4,
    border: `1px solid transparent`,

    "&:focus": {
      outline: `3px solid ${alpha(lightBlue[200], 0.2)}`,
      borderColor: lightBlue[300]
    },
    "&:hover": {
      boxShadow: `0px -3px 0px 0px ${blueGrey[300]} inset`
    },
    "&.Mui-selected": {
      color: lightBlue[900]
    },
    "&$disabled": {
      color: palette.primary[200]
    }
  },
  subjectIndicator: {
    height: 3,
    background: lightBlue[500],
    borderRadius: 100
  },
  subjectsRoot: {
    height: 6,
    display: "flex",
    alignItems: "center",
    "&.MuiTabs-root": {
      overflow: "unset !important"
    },
    "& .MuiTabs-fixed": {
      overflow: "unset !important"
    }
  }
}))
